import organizations from './organizations'
import actions from './actions'
import offices from './offices'
import users from './users'

export default {
  partners: {
    namespaced: true,
    modules: {
      organizations,
      actions,
      offices,
      users
    }
  }
}
